var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"app-more-btn"},_vm.listeners),[_c('filters-icon'),_vm._t("default"),_c('arrow-select')],2)}
var staticRenderFns = []

export { render, staticRenderFns }